import { render } from "./SubmissionArchiveDialog.vue?vue&type=template&id=52a6af15"
import script from "./SubmissionArchiveDialog.vue?vue&type=script&lang=js"
export * from "./SubmissionArchiveDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__